import { render, staticRenderFns } from "./FaqNoticeBar.vue?vue&type=template&id=c84d411e&scoped=true&"
import script from "./FaqNoticeBar.vue?vue&type=script&lang=js&"
export * from "./FaqNoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./FaqNoticeBar.vue?vue&type=style&index=0&id=c84d411e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d411e",
  null
  
)

export default component.exports